export default __webpack_public_path__ + "static/media/06_kuna_skalni_Kasina-min.cda8d45e.jpg";